import { render } from "./CondicionesPrivacidad.vue?vue&type=template&id=b1c33f22"
const script = {}

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__